import { api } from './axios'

const base = '/carrier-quota-config'

export interface CarrierQuotaEquipmentRow {
  equipmentId: number
  equipmentName: string
  dailyQuota: number
  monthlyQuota: number
}

export interface CarrierQuotaCarrierBlock {
  carrierId: number
  tradeName: string
  totalDailyQuota: number
  totalMonthlyQuota: number
  equipmentQuotas: CarrierQuotaEquipmentRow[]
}

export interface CarrierQuotaConfigMatrix {
  year: number
  month: number
  workingDays: number
  isPeriodPersisted: boolean
  canEdit: boolean
  carriers: CarrierQuotaCarrierBlock[]
}

export interface CarrierQuotaSaveLine {
  carrierId: number
  equipmentId: number
  dailyQuota: number
}

export const getCarrierQuotaConfigMatrix = async (year: number, month: number) => {
  const response = await api.get<{ data: CarrierQuotaConfigMatrix }>(base, {
    params: { year, month },
  })
  return response.data.data
}

export const putCarrierQuotaConfig = async (payload: {
  year: number
  month: number
  workingDays: number
  lines: CarrierQuotaSaveLine[]
}) => {
  const response = await api.put(base, payload)
  return response.data
}
